import React from "react";

function Terms() {
  return (
    <main className="terms-page">
      <style>{`
        .terms-page {
          min-height: 100vh;
          background:
            radial-gradient(circle at top left, rgba(16, 185, 129, 0.13), transparent 32rem),
            radial-gradient(circle at bottom right, rgba(37, 211, 102, 0.12), transparent 30rem),
            #f7fbf9;
          padding: 40px 16px;
          color: #475569;
        }

        .terms-shell {
          max-width: 1050px;
          margin: 0 auto;
        }

        .terms-card {
          background: rgba(255, 255, 255, 0.94);
          border: 1px solid rgba(16, 185, 129, 0.13);
          border-radius: 30px;
          box-shadow: 0 24px 70px rgba(15, 23, 42, 0.08);
          overflow: hidden;
        }

        .terms-hero {
          padding: 42px 34px 30px;
          border-bottom: 1px solid #e2e8f0;
          background:
            linear-gradient(135deg, rgba(236, 253, 245, 0.95), rgba(255, 255, 255, 0.9)),
            radial-gradient(circle at top right, rgba(37, 211, 102, 0.22), transparent 22rem);
        }

        .brand-pill {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 13px;
          border-radius: 999px;
          background: #ecfdf5;
          color: #047857;
          font-size: 12px;
          font-weight: 800;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          margin-bottom: 18px;
          border: 1px solid rgba(16, 185, 129, 0.2);
        }

        .brand-dot {
          width: 8px;
          height: 8px;
          border-radius: 999px;
          background: #25d366;
          box-shadow: 0 0 0 5px rgba(37, 211, 102, 0.14);
        }

        .terms-hero h1 {
          margin: 0;
          color: #0f172a;
          font-size: clamp(2rem, 5vw, 3.4rem);
          line-height: 1.05;
          letter-spacing: -0.05em;
          font-weight: 900;
        }

        .terms-hero p {
          margin: 16px 0 0;
          color: #64748b;
          font-size: 15px;
          line-height: 1.75;
          max-width: 760px;
        }

        .terms-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 24px;
        }

        .terms-meta span {
          display: inline-flex;
          align-items: center;
          padding: 9px 12px;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.8);
          border: 1px solid #dbeafe;
          color: #334155;
          font-size: 13px;
          font-weight: 700;
        }

        .terms-content {
          padding: 34px;
          font-size: 15px;
          line-height: 1.82;
        }

        .terms-content h2 {
          color: #0f172a;
          font-size: 22px;
          line-height: 1.25;
          margin: 42px 0 14px;
          letter-spacing: -0.025em;
          font-weight: 900;
        }

        .terms-content h2:first-child {
          margin-top: 0;
        }

        .terms-content h3 {
          color: #0f172a;
          font-size: 17px;
          margin: 24px 0 10px;
          font-weight: 850;
        }

        .terms-content p {
          margin: 0 0 15px;
          color: #475569;
        }

        .terms-content strong {
          color: #0f172a;
          font-weight: 850;
        }

        .terms-content a {
          color: #059669;
          font-weight: 800;
          text-decoration: none;
          word-break: break-word;
        }

        .terms-content a:hover {
          text-decoration: underline;
        }

        .terms-content ul {
          margin: 12px 0 18px;
          padding-left: 22px;
        }

        .terms-content li {
          margin-bottom: 8px;
          color: #475569;
        }

        .toc-box {
          margin: 30px 0 34px;
          padding: 22px;
          border-radius: 24px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
        }

        .toc-box h2 {
          margin-top: 0;
          margin-bottom: 14px;
          font-size: 18px;
        }

        .toc-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 10px;
        }

        .toc-grid a {
          display: block;
          padding: 11px 13px;
          border-radius: 14px;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          color: #0f766e;
          font-size: 13px;
          font-weight: 850;
        }

        .notice-box {
          margin: 20px 0;
          padding: 18px;
          border-radius: 20px;
          background: #fff7ed;
          border: 1px solid #fed7aa;
          color: #9a3412;
        }

        .notice-box strong {
          color: #9a3412;
        }

        .green-box {
          margin: 20px 0;
          padding: 18px;
          border-radius: 20px;
          background: #ecfdf5;
          border: 1px solid #bbf7d0;
          color: #065f46;
        }

        .green-box strong {
          color: #064e3b;
        }

        .contact-box {
          margin-top: 28px;
          padding: 22px;
          border-radius: 24px;
          background: linear-gradient(135deg, #ecfdf5, #ffffff);
          border: 1px solid rgba(16, 185, 129, 0.18);
        }

        .back-top {
          display: inline-flex;
          margin-top: 12px;
          font-size: 13px;
          font-weight: 800;
          color: #059669;
        }

        @media (max-width: 768px) {
          .terms-page {
            padding: 22px 12px;
          }

          .terms-hero {
            padding: 30px 20px 24px;
          }

          .terms-content {
            padding: 24px 20px;
          }

          .toc-grid {
            grid-template-columns: 1fr;
          }

          .terms-content h2 {
            font-size: 20px;
          }
        }
      `}</style>

      <div className="terms-shell">
        <article className="terms-card">
          <header className="terms-hero">
            <div className="brand-pill">
              <span className="brand-dot" />
              Zaviramed
            </div>

            <h1>Terms and Conditions</h1>

            <p>
              These Terms and Conditions govern your access to and use of Zaviramed’s
              website, WhatsApp-based teleconsultation services, doctor support,
              prescription services, pharmacy-related services, payment services,
              corporate healthcare access, and other related services.
            </p>

            <div className="terms-meta">
              <span>Company: ZAVIRAMED LIMITED</span>
              <span>Last updated: May 02, 2026</span>
              <span>Support: support@zaviramed.com.ng</span>
            </div>
          </header>

          <section className="terms-content">
            <p>
              These Terms and Conditions constitute a legally binding agreement made
              between you, whether personally or on behalf of an entity, and{" "}
              <strong>ZAVIRAMED LIMITED</strong> concerning your access to and use
              of our services.
            </p>

            <p>
              By accessing, using, registering for, paying for, or communicating with
              Zaviramed through our website, WhatsApp, email, phone, doctor dashboard,
              prescription system, pharmacy service, or any related channel, you agree
              that you have read, understood, and accepted these Terms and Conditions.
              If you do not agree with these Terms, you should not use our services.
            </p>

            <div className="notice-box">
              <strong>Important medical notice:</strong> Zaviramed is not an emergency
              medical service. If you have a medical emergency, severe symptoms, chest
              pain, difficulty breathing, loss of consciousness, severe bleeding,
              stroke symptoms, suicidal thoughts, poisoning, or any urgent condition,
              please go to the nearest hospital or emergency facility immediately.
            </div>

            <div className="toc-box" id="toc">
              <h2>Table of Contents</h2>

              <div className="toc-grid">
                <a href="#services">1. Our Services</a>
                <a href="#eligibility">2. Eligibility</a>
                <a href="#medical-disclaimer">3. Medical Disclaimer</a>
                <a href="#user-responsibilities">4. User Responsibilities</a>
                <a href="#consultations">5. Consultations</a>
                <a href="#whatsapp">6. WhatsApp Communication</a>
                <a href="#prescriptions">7. Prescriptions</a>
                <a href="#pharmacy">8. Pharmacy Services</a>
                <a href="#payments">9. Payments and Subscriptions</a>
                <a href="#corporate">10. Corporate Plans</a>
                <a href="#privacy">11. Privacy and Data</a>
                <a href="#prohibited">12. Prohibited Use</a>
                <a href="#third-party">13. Third-Party Services</a>
                <a href="#availability">14. Availability of Services</a>
                <a href="#liability">15. Limitation of Liability</a>
                <a href="#termination">16. Suspension or Termination</a>
                <a href="#changes">17. Changes to These Terms</a>
                <a href="#contact">18. Contact Us</a>
              </div>
            </div>

            <h2 id="services">1. Our Services</h2>

            <p>
              Zaviramed provides a WhatsApp-first telemedicine platform that connects
              clients and patients with doctors for remote medical consultations and
              related healthcare support.
            </p>

            <p>Our services may include:</p>

            <ul>
              <li>WhatsApp-based medical consultations;</li>
              <li>Doctor review and medical guidance;</li>
              <li>Follow-up health support;</li>
              <li>Electronic prescriptions where medically appropriate;</li>
              <li>Referral guidance where physical care is required;</li>
              <li>Pharmacy costing and medication delivery support;</li>
              <li>Corporate healthcare access for organizations;</li>
              <li>Health education, campaigns, outreach, and events;</li>
              <li>Payment processing for consultations, subscriptions, or related services.</li>
            </ul>

            <p>
              Zaviramed may update, expand, suspend, or modify parts of the service
              from time to time in order to improve operations, comply with law, or
              better serve users.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="eligibility">2. Eligibility</h2>

            <p>
              By using Zaviramed, you confirm that you are legally able to use our
              services and provide the information required for medical support.
            </p>

            <p>
              If you are using Zaviramed on behalf of a child, dependent, employee,
              family member, or another person, you confirm that you have the legal
              right or appropriate permission to provide their information and request
              healthcare support on their behalf.
            </p>

            <p>
              We may refuse, suspend, or restrict access where we believe the service
              is being used unlawfully, fraudulently, abusively, or in a way that may
              endanger a patient, healthcare worker, partner, or the platform.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="medical-disclaimer">3. Medical Disclaimer</h2>

            <p>
              Zaviramed provides remote healthcare support based on the information
              supplied by the patient or user. Teleconsultation has limitations because
              the doctor may not be able to physically examine you, perform immediate
              investigations, or observe certain clinical signs directly.
            </p>

            <p>
              Our doctors may provide advice, health education, prescriptions, follow-up
              guidance, or referral recommendations based on clinical judgment. However,
              the final quality of the consultation depends significantly on the accuracy,
              completeness, and timeliness of the information you provide.
            </p>

            <div className="notice-box">
              <strong>Emergency care:</strong> Zaviramed must not be used as a substitute
              for emergency care, hospital care, surgery, physical examination when
              required, admission, or urgent medical intervention.
            </div>

            <p>
              If a Zaviramed doctor advises you to visit a hospital, laboratory,
              specialist, pharmacy, or emergency facility, you are responsible for
              following that advice promptly.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="user-responsibilities">4. User Responsibilities</h2>

            <p>By using Zaviramed, you agree to:</p>

            <ul>
              <li>Provide accurate, complete, and truthful information;</li>
              <li>Provide correct name, age, sex, phone number, email address, and health complaint where required;</li>
              <li>Disclose relevant medical history, allergies, pregnancy status, current medications, previous diagnoses, and test results where necessary;</li>
              <li>Use Zaviramed only for lawful healthcare-related purposes;</li>
              <li>Respond to doctors or support staff when further information is needed;</li>
              <li>Seek physical medical care when advised;</li>
              <li>Not abuse, threaten, harass, insult, or endanger doctors, staff, pharmacists, or other users;</li>
              <li>Not use Zaviramed to obtain medication fraudulently or misuse prescriptions;</li>
              <li>Not impersonate another person or provide false medical details.</li>
            </ul>

            <p>
              You understand that failure to provide accurate information may affect
              the quality, safety, or appropriateness of medical advice given through
              the platform.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="consultations">5. Consultations</h2>

            <p>
              Consultations on Zaviramed are generally conducted through WhatsApp or
              related digital channels. A doctor may ask questions, request additional
              details, review symptoms, provide medical advice, recommend tests, refer
              you for physical care, or issue a prescription where appropriate.
            </p>

            <p>
              Response times may vary depending on doctor availability, patient volume,
              network issues, working hours, emergency workload, or other operational
              factors. Zaviramed will make reasonable efforts to support users, but we
              do not guarantee instant doctor response at all times.
            </p>

            <p>
              A consultation may be declined, paused, escalated, or redirected to a
              physical hospital if the doctor believes the case cannot be safely handled
              remotely.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="whatsapp">6. WhatsApp Communication</h2>

            <p>
              Zaviramed is a WhatsApp-first healthcare platform. By using our services,
              you agree that we may contact you through WhatsApp, phone call, SMS, email,
              or other contact details you provide.
            </p>

            <p>
              WhatsApp conversations may be subject to WhatsApp’s own rules, including
              message delivery limits, template messaging rules, business messaging
              restrictions, and conversation windows. In some cases, you may need to
              reply to a WhatsApp message before we can continue free-form communication
              with you.
            </p>

            <p>
              You are responsible for ensuring that the phone number you provide is
              active, reachable, and controlled by you or by someone authorized to act
              on your behalf.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="prescriptions">7. Prescriptions</h2>

            <p>
              Zaviramed doctors may issue electronic prescriptions only where they
              consider it medically appropriate. A prescription is not guaranteed for
              every consultation.
            </p>

            <p>
              You agree not to alter, forge, resell, duplicate, misuse, or unlawfully
              distribute prescriptions issued through Zaviramed.
            </p>

            <p>
              A prescription may be refused where the doctor believes that a physical
              examination, laboratory test, specialist review, emergency care, or hospital
              visit is required before medication can be safely recommended.
            </p>

            <p>
              You are responsible for taking medications exactly as prescribed and for
              informing the doctor about allergies, pregnancy, breastfeeding, current
              medications, chronic illnesses, and previous adverse drug reactions.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="pharmacy">8. Pharmacy Services</h2>

            <p>
              Zaviramed may support pharmacy-related workflows, including sending
              prescription requests to pharmacies for costing, helping patients receive
              medication prices, and facilitating communication between patients and
              pharmacy partners.
            </p>

            <p>
              Drug prices, availability, delivery timelines, dispensing decisions, and
              fulfilment may depend on the pharmacy or delivery partner involved.
              Zaviramed may facilitate the process but does not guarantee that every
              medication will be available at all times.
            </p>

            <p>
              Patients are responsible for reviewing medication costs, confirming
              delivery details, and following pharmacist or doctor instructions where
              applicable.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="payments">9. Payments and Subscriptions</h2>

            <p>
              Some Zaviramed services may require payment. These may include
              per-consultation payments, subscription plans, corporate access,
              prescription-related payments, pharmacy-related payments, delivery-related
              charges, or other paid services.
            </p>

            <p>
              Payments may be processed through third-party providers such as Paystack.
              By making payment through such providers, you agree to their payment terms,
              privacy notices, transaction rules, and dispute processes.
            </p>

            <p>
              Zaviramed may offer free consultations, promotional access, discounted
              plans, subscription packages, or corporate plans at its discretion. We may
              change pricing, payment rules, plan structure, or access conditions from
              time to time.
            </p>

            <h3>Refunds</h3>

            <p>
              Refunds, where applicable, may be reviewed on a case-by-case basis.
              Payments may not be refundable where a doctor has already reviewed the
              case, a consultation has started, a prescription service has been processed,
              a pharmacy request has been costed, or a third-party service has already
              been used.
            </p>

            <p>
              If you believe a payment was made in error, contact us at{" "}
              <a href="mailto:support@zaviramed.com.ng">support@zaviramed.com.ng</a>.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="corporate">10. Corporate Plans</h2>

            <p>
              Zaviramed may provide healthcare access to employees, students, members,
              or beneficiaries through corporate plans, partnerships, schools, NGOs,
              companies, institutions, or community programs.
            </p>

            <p>
              Where your access is provided through an organization, certain usage
              information may be reported to the organization in aggregated or
              administrative form, such as number of consultations, general service
              usage, plan utilization, or operational summaries. We do not intend to
              disclose detailed confidential medical information to an employer or
              organization without appropriate legal basis, consent, or necessity.
            </p>

            <p>
              Corporate access may be subject to the agreement between Zaviramed and
              the organization providing the benefit.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="privacy">11. Privacy and Data</h2>

            <p>
              Your privacy is important to us. Our collection, use, processing, storage,
              and sharing of personal information is governed by our Privacy Policy.
            </p>

            <p>
              By using Zaviramed, you agree that we may collect and process information
              necessary to provide healthcare support, including your name, phone number,
              email address, age, sex, health complaint, medical history, test results,
              images, videos, voice notes, prescriptions, payment information, and other
              information required to provide our services.
            </p>

            <p>
              For privacy-related questions, contact us at{" "}
              <a href="mailto:support@zaviramed.com.ng">support@zaviramed.com.ng</a>.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="prohibited">12. Prohibited Use</h2>

            <p>You agree not to use Zaviramed to:</p>

            <ul>
              <li>Commit fraud or impersonate another person;</li>
              <li>Provide false symptoms or medical history;</li>
              <li>Obtain medications unlawfully;</li>
              <li>Harass, threaten, abuse, or intimidate healthcare workers or staff;</li>
              <li>Upload harmful, illegal, abusive, or misleading content;</li>
              <li>Interfere with the security or operation of the platform;</li>
              <li>Use the platform for spam, scams, or unauthorized marketing;</li>
              <li>Violate any applicable law, regulation, or professional standard.</li>
            </ul>

            <p>
              We may restrict, suspend, or terminate access if we believe a user has
              violated this section.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="third-party">13. Third-Party Services</h2>

            <p>
              Zaviramed may rely on third-party services to operate effectively. These
              may include WhatsApp, payment processors, email providers, hosting providers,
              analytics tools, pharmacies, laboratories, delivery partners, hospitals,
              or other healthcare-related partners.
            </p>

            <p>
              Third-party services may have their own terms, policies, fees, rules, and
              privacy practices. Zaviramed is not responsible for every action, omission,
              outage, delay, policy, or failure of third-party providers.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="availability">14. Availability of Services</h2>

            <p>
              We aim to keep Zaviramed available and responsive, but we do not guarantee
              uninterrupted, error-free, or always-available service.
            </p>

            <p>
              Service may be delayed, interrupted, or unavailable due to maintenance,
              internet problems, WhatsApp restrictions, doctor availability, payment
              provider downtime, hosting issues, technical errors, force majeure events,
              or circumstances beyond our control.
            </p>

            <p>
              We may modify, suspend, discontinue, or restrict any part of the service
              where necessary for safety, compliance, operational, technical, or business
              reasons.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="liability">15. Limitation of Liability</h2>

            <p>
              To the maximum extent permitted by law, Zaviramed, its directors, employees,
              doctors, contractors, affiliates, and partners will not be liable for
              indirect, incidental, special, consequential, exemplary, or punitive damages
              arising from your use of the services.
            </p>

            <p>Zaviramed will not be responsible for harm or loss caused by:</p>

            <ul>
              <li>False, incomplete, delayed, or misleading information provided by a user;</li>
              <li>Failure to seek emergency or physical medical care when needed;</li>
              <li>Misuse of prescriptions or medications;</li>
              <li>Third-party service failures;</li>
              <li>Network, hosting, WhatsApp, payment, or delivery issues;</li>
              <li>Unauthorized access caused by user negligence;</li>
              <li>Events outside our reasonable control.</li>
            </ul>

            <p>
              Nothing in these Terms is intended to exclude liability that cannot be
              excluded under applicable law.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="termination">16. Suspension or Termination</h2>

            <p>
              We may suspend, restrict, or terminate your access to Zaviramed if we
              reasonably believe that you have violated these Terms, misused the platform,
              failed to make required payment, abused staff or doctors, provided fraudulent
              information, used the service unlawfully, or created risk for other users,
              healthcare workers, partners, or the platform.
            </p>

            <p>
              You may stop using Zaviramed at any time. Some information may be retained
              where required for legal, medical, security, fraud-prevention, accounting,
              or operational reasons.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="changes">17. Changes to These Terms</h2>

            <p>
              We may update these Terms and Conditions from time to time. The updated
              version will be indicated by a revised “Last updated” date at the top of
              this page.
            </p>

            <p>
              If we make material changes, we may notify users through our website,
              WhatsApp, email, or other reasonable communication channels. Continued use
              of Zaviramed after changes means you accept the updated Terms.
            </p>

            <a className="back-top" href="#toc">Back to top</a>

            <h2 id="contact">18. Contact Us</h2>

            <div className="contact-box">
              <p>
                If you have questions, complaints, or comments about these Terms and
                Conditions, you may contact us using the details below:
              </p>

              <p>
                <strong>ZAVIRAMED LIMITED</strong>
                <br />
                Email:{" "}
                <a href="mailto:support@zaviramed.com.ng">
                  support@zaviramed.com.ng
                </a>
                <br />
                Website:{" "}
                <a
                  href="https://www.zaviramed.com.ng"
                  target="_blank"
                  rel="noreferrer"
                >
                  www.zaviramed.com.ng
                </a>
              </p>
            </div>

            <div className="green-box">
              <strong>Effective date:</strong> These Terms and Conditions were last
              updated on <strong>May 02, 2026</strong>.
            </div>

            <a className="back-top" href="#toc">Back to top</a>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Terms;